import { CardContent, Grid } from "@mui/material";
import { MprcCard } from "components";
import { IconHistory } from "components/icons/IconHistory";
import { MprcButton } from "components/MprcButton";
import { MprcContainer } from "components/MprcContainer";
import { AuditLogEntityType } from "generated/CoreApi_v1";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { AuditLogDialog } from "views/common/AuditLog/AuditLogDialog";

////////////////////////////////////////////////////////////////////////////

interface IProps {
    auditEntityType: AuditLogEntityType;
    name: string;
}

////////////////////////////////////////////////////////////////////////////
/**
 * Rodapé para Visualização do Histórico
 * @param props
 */
export const EditHistoryFooter: React.FC<IProps> = (props) => {
    const [dialog, setDialog] = useState<any>();
    const { t } = useTranslation();

    ////////////////////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <div>
            {dialog}

            <MprcContainer>
                <MprcCard>
                    <CardContent>
                        <Grid container justifyContent="flex-start" alignItems="center">
                            <Grid>
                                <MprcButton
                                    onClick={
                                        () => setDialog(
                                            <AuditLogDialog
                                                title={props.name}
                                                entityType={props.auditEntityType}
                                                onClose={() => setDialog(null)}
                                            />
                                        )
                                    }
                                    color="muted" disableRipple>
                                    <IconHistory size="2x" fixedWidth />
                                    <span>{t("EventLog.EventLogDialog.Title")}</span>
                                </MprcButton>
                            </Grid>
                        </Grid>
                    </CardContent>
                </MprcCard>
            </MprcContainer>
        </div>
    );
};
